export default "__VITE_ASSET__d7fb32f5__"